import { render, staticRenderFns } from "./MpChat.vue?vue&type=template&id=43e2422b&scoped=true&"
import script from "./MpChat.vue?vue&type=script&lang=js&"
export * from "./MpChat.vue?vue&type=script&lang=js&"
import style0 from "./MpChat.vue?vue&type=style&index=0&id=43e2422b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e2422b",
  null
  
)

component.options.__file = "MpChat.vue"
export default component.exports